import React from 'react'

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'

const UserManagerModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Let's manage users and roles</ModalHeader>
        <ModalCloseButton />
        <ModalBody>What would be this content?</ModalBody>

        <ModalFooter>
          <HStack mt={4}>
            <Button
              colorScheme="blackAlpha"
              size="sm"
              onClick={onClose}>
              Close
            </Button>
            <Button
              colorScheme="orange"
              size="sm">
              Save changes
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

UserManagerModal.propTypes = {}

export default UserManagerModal
